"use client";

import { type ReactNode, useMemo, useState } from "react";

import { useTranslations } from "next-intl";
import {
  type HeroEmailSplit,
  splitHeroEmailBody,
  splitHeroPortalBody,
} from "./hero-vorgang-email-split";
import {
  HERO_VORGANG_ACTION_BTN,
  HERO_VORGANG_QUOTE_COLOR,
} from "./hero-vorgang-tokens";

export function HeroVorgangMessageBody(props: {
  readonly channel: "email" | "portal";
  readonly direction: "inbound" | "outbound";
  readonly fullPlain: string;
  readonly signatureName?: string;
}): ReactNode {
  const t = useTranslations("marketing.heroVorgangMessageBody");
  const [showFullHistory, setShowFullHistory] = useState<boolean>(false);

  const split: HeroEmailSplit = useMemo((): HeroEmailSplit => {
    if (props.channel === "portal") {
      return splitHeroPortalBody(props.fullPlain);
    }
    return splitHeroEmailBody(props.fullPlain, props.direction);
  }, [props.channel, props.direction, props.fullPlain]);

  const showSignature: boolean =
    props.direction === "outbound" &&
    props.channel === "email" &&
    props.signatureName !== undefined &&
    props.signatureName.length > 0;

  return (
    <div style={{ marginTop: 8 }}>
      <p
        style={{
          margin: 0,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          fontSize: 13,
          lineHeight: 1.62,
          color: "#2A2F3A",
        }}
      >
        {split.visible}
      </p>

      {showSignature ? (
        <p
          style={{
            margin: "8px 0 0",
            fontSize: 10,
            lineHeight: 1.35,
            color: "rgba(11,15,25,0.30)",
          }}
        >
          {t("signatur")} {props.signatureName} {t("angehaengt")}
        </p>
      ) : null}

      {showFullHistory && split.hidden !== null ? (
        <div
          style={{
            marginTop: 10,
            paddingLeft: 10,
            borderLeft: `2px solid ${HERO_VORGANG_QUOTE_COLOR}`,
            fontSize: 11,
            lineHeight: 1.55,
            color: HERO_VORGANG_QUOTE_COLOR,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {split.hidden}
        </div>
      ) : null}

      {split.canToggle ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: 12,
          }}
        >
          <button
            type="button"
            className="mkhero-vorgang-verlauf-btn"
            aria-expanded={showFullHistory}
            onClick={() => {
              setShowFullHistory((prev: boolean) => !prev);
            }}
            style={HERO_VORGANG_ACTION_BTN}
          >
            {showFullHistory ? t("verlaufAusblenden") : t("verlaufAnzeigen")}
          </button>
        </div>
      ) : null}
    </div>
  );
}
